import { StatusViewModel, UserBankAccountStatus } from '../../models';

export function resolveBankAccountStatus(
  status: UserBankAccountStatus,
  statusDisplayName: string,
): StatusViewModel {
  switch (status) {
    case UserBankAccountStatus.Verified:
      return {
        color: 'success',
        icon: 'icon-check',
        label: statusDisplayName,
      };
    case UserBankAccountStatus.Rejected:
      return {
        color: 'error',
        icon: 'icon-x',
        label: statusDisplayName,
      };
    case UserBankAccountStatus.New:
      return {
        color: 'gray',
        icon: 'icon-clock',
        label: statusDisplayName,
      };
    case UserBankAccountStatus.MatchingCardNumberWithKyc:
    case UserBankAccountStatus.CardNumberWithKycMatched:
    case UserBankAccountStatus.ExtractingCardNumberInfo:
    default:
      return {
        color: 'warning',
        icon: 'icon-loading-02',
        label: statusDisplayName,
      };
  }
}
